import { useEffect } from 'react';
import { Loader } from '../../components/loader/loader';
import { useInitialLoadForDeepLinks } from '../common/hooks/use-initial-load-for-deep-links.hook';
import { history, URL_CONSTANTS } from '../../utils/history';

export const FieldsNewDeepLinkContainer = () => {
  const {
    isWorkspaceFetched,
    defaultWorkspace,
    isOrgFetched,
    defaultOrg,
    isPropertyFetched,
    defaultProperty
  } = useInitialLoadForDeepLinks({
    loadPropertyList: true
  });

  // We only navigate after org is fetched and property is fetched, and if no org is found we wait for workspace to be fetched to navigate to workspace level
  const propertyReady = isOrgFetched && defaultOrg && isPropertyFetched;
  const fallbackReady = isOrgFetched && !defaultOrg && isWorkspaceFetched;
  const shouldNavigate = propertyReady || fallbackReady;

  useEffect(() => {
    if (!shouldNavigate) return;

    let urlToNavigate = URL_CONSTANTS.HALL_OF_ENTITIES();

    if (defaultProperty?.id && defaultProperty?.org_id) {
      urlToNavigate =
        URL_CONSTANTS.ALL_FIELDS({
          orgId: defaultProperty.org_id,
          farmId: defaultProperty.id
        }) + `?action=CREATE-FIELD`;
    } else if (defaultOrg?.id) {
      urlToNavigate = URL_CONSTANTS.HALL_OF_ENTITIES({
        workspaceId: defaultOrg.workspace_id,
        orgId: defaultOrg.id
      });
    } else if (defaultWorkspace?.id) {
      urlToNavigate = URL_CONSTANTS.HALL_OF_ENTITIES({
        workspaceId: defaultWorkspace.id
      });
    }

    history.push(urlToNavigate);
  }, [
    defaultProperty?.id,
    defaultProperty?.org_id,
    defaultOrg?.id,
    defaultOrg?.workspace_id,
    defaultWorkspace?.id,
    shouldNavigate
  ]);

  return <Loader mask />;
};
